// import React, { useState, useEffect } from "react";
// import apiService from "../../Common/Configurations/APIService";
// import config from "../../Common/Configurations/APIConfig";
// import { useAuth } from "../../Common/Configurations/AuthContext";
// import moment from "moment";
// import Header from "../../Common/Layout/Header";
// import AccountTabs from "../AllTabs/AccountTabs";

// const AgentLedger = () => {
//   const { user } = useAuth();
//   const [statement, setStatement] = useState(null);
//   const [agents, setAgents] = useState([]); 
//   const [selectedRefId, setSelectedRefId] = useState("");
//   const [fromDate, setFromDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
//   const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));
//   const [loading, setLoading] = useState(false);

//   useEffect(() => {
//     const fetchAgentsAndCorps = async () => {
//       try {
//         const customers = await apiService.getAll(`${config.GETALLCUSTOMERSBYCOMPANYID}/${user.cid}`);
//         const corporates = await apiService.getAll(`${config.GETALLCOMPANIES}?companyType=CORPORATE&parentCompanyId=${user.cid}`);
        
//         // Changed format: Name first, Type in suffix so typing letters works instantly
//         const combined = [
//           ...customers.map(c => ({ id: c.customerId, name: `${c.customerName} (Agent)` })),
//           ...corporates.map(c => ({ id: c.companyId, name: `${c.companyName} (Corporate)` })),
//         ];

//         // IMPORTANT: Sort alphabetically so jumping to letters works correctly in the dropdown
//         combined.sort((a, b) => a.name.localeCompare(b.name));
        
//         setAgents(combined);
//       } catch (err) {
//         console.error("Error fetching parties:", err);
//       }
//     };
//     if (user?.cid) fetchAgentsAndCorps();
//   }, [user?.cid]);

//   const fetchStatement = async () => {
//     if (!selectedRefId) return alert("Please select an Agent or Corporate");
//     setLoading(true);
//     try {
//       const res = await apiService.getAll(`${config.GETSTATEMENT}/${selectedRefId}?fromDate=${fromDate}&toDate=${toDate}`);
//       console.log("Fetched Statement:", res);
//       setStatement(res);
//     } catch (error) {
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const format = (val) => Number(val).toLocaleString("en-IN", { minimumFractionDigits: 2 });

//   return (
//      <div id="layout-wrapper">
//           <Header User={user} />
//           <div className="main-content">
//             <div className="page-content">
//               <div className="container-fluid">
//                 <div className="col-xl-12">
//                   <div className="card shadow-sm">
//                     {/* 1. TABS SECTION */}
//                     <div className="p-2">
//                       <AccountTabs pageName="AGENTLEDGER" />
//                     </div>
    
//                     <div className="card-body p-0">
//       <div className="report-container">
//         <div className="report-header">
//           <div>
//             <h2 className="report-title">Agent & Corporate Ledger</h2>
//             <p className="company-id">Accounts Receivable & Transaction History</p>
//           </div>
//         </div>

//         {/* Filter Bar */}
//         <div className="filter-bar no-print">
//           <div className="filter-group flex-grow">
//             <label>Select Agent / Corporate (Type to search)</label>
//             <select 
//               className="custom-input" 
//               value={selectedRefId} 
//               onChange={e => setSelectedRefId(e.target.value)}
//             >
//               <option value="">-- Choose Party --</option>
//               {agents.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
//             </select>
//           </div>
//           <div className="filter-group">
//             <label>From Date</label>
//             <input type="date" className="custom-input" value={fromDate} onChange={e => setFromDate(e.target.value)} />
//           </div>
//           <div className="filter-group">
//             <label>To Date</label>
//             <input type="date" className="custom-input" value={toDate} onChange={e => setToDate(e.target.value)} />
//           </div>
//           <div className="filter-group">
//             <button className="search-button" onClick={fetchStatement} disabled={loading}>
//               {loading ? "Fetching..." : "View Ledger"}
//             </button>
//           </div>
//         </div>

//         {statement && (
//           <div className="statement-content">
//             <div className="statement-summary">
//               <div className="party-details">
//                 {/* <h4 className="party-name-heading">{statement.partyName || agents.find(p => p.id === selectedRefId)?.name}</h4> */}
//                 <p>Period: <strong>{moment(fromDate).format("DD MMM YYYY")}</strong> - <strong>{moment(toDate).format("DD MMM YYYY")}</strong></p>
//               </div>
              
//               <div className="balance-section text-end">
//                 <div className="balance-label">Closing Balance</div>
//                 <div className={`balance-amount ${statement.closingBalance >= 0 ? "text-red" : "text-green"}`}>
//                    ₹ {format(Math.abs(statement.closingBalance))}
//                    <span className="dr-cr-badge">{statement.closingBalance >= 0 ? "DR" : "CR"}</span>
//                 </div>
                
//                 {/* Added status badges for visual consistency with Supplier screen */}
//                 <div className={`balance-status ${statement.closingBalance >= 0 ? "status-payable" : "status-advance"}`}>
//                     {statement.closingBalance >= 0 ? "Outstanding Due" : "Advance Received"}
//                 </div>
//               </div>
//             </div>

//             <div className="table-responsive">
//               <table className="ledger-table">
//                 <thead>
//                   <tr>
//                     <th>Date</th>
//                     <th>Description</th>
//                     <th>Voucher #</th>
//                     <th className="text-end">Debit (Dr)</th>
//                     <th className="text-end">Credit (Cr)</th>
//                     <th className="text-end">Balance</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   <tr className="opening-balance-row">
//                     <td colSpan="3"><strong>Opening Balance</strong></td>
//                     <td colSpan="2"></td>
//                     <td className="text-end font-bold">{format(statement.openingBalance)}</td>
//                   </tr>
//                   {statement.transactions.map((t, i) => (
//                     <tr key={i} className="transaction-row">
//                       <td className="date-col">{moment(t.date).format("DD/MM/YYYY")}</td>
//                       <td className="desc-col">{t.description}</td>
//                       <td>{t.invoiceNumber}</td>
//                       <td className="text-end text-red">{t.debit > 0 ? format(t.debit) : "-"}</td>
//                       <td className="text-end text-green">{t.credit > 0 ? format(t.credit) : "-"}</td>
//                       <td className="text-end font-bold text-dark">{format(t.runningBalance)}</td>
//                     </tr>
//                   ))}
//                 </tbody>
//                 <tfoot>
//                   <tr className="footer-row">
//                     <td colSpan="3">Totals</td>
//                     <td className="text-end text-red">{format(statement.totalDebit)}</td>
//                     <td className="text-end text-green">{format(statement.totalCredit)}</td>
//                     <td className="text-end highlight-total">{format(statement.closingBalance)}</td>
//                   </tr>
//                 </tfoot>
//               </table>
//             </div>
//             <div className="action-footer no-print">
//                <button className="print-btn" onClick={() => window.print()}>Print Statement</button>
//             </div>
//           </div>
         
//         )}
//       </div>

//       <style jsx>{`
//         .ledger-wrapper { padding: 30px; background-color: #f4f7f6; min-height: 100vh; font-family: 'Inter', sans-serif; }
//         .report-container { background: white; border-radius: 12px; border-top: 6px solid #0056b3; box-shadow: 0 10px 25px rgba(0,0,0,0.05); max-width: 1150px; margin: 0 auto; overflow: hidden; }
//         .report-header { background: #0056b3; color: white; padding: 25px 35px; }
//         .report-title { font-size: 26px; margin: 0; font-weight: 800; color: #fff; letter-spacing: -0.5px; }
//         .company-id { font-size: 14px; opacity: 0.85; margin-top: 5px; }
        
//         .filter-bar { padding: 20px 35px; background: #f8f9fa; display: flex; gap: 20px; align-items: flex-end; border-bottom: 1px solid #eef2f6; }
//         .filter-group { display: flex; flex-direction: column; }
//         .filter-group.flex-grow { flex: 1; }
//         .filter-group label { font-size: 11px; font-weight: 700; color: #64748b; margin-bottom: 6px; text-transform: uppercase; letter-spacing: 0.5px; }
//         .custom-input { padding: 10px 14px; border: 1px solid #cbd5e1; border-radius: 8px; font-size: 14px; outline: none; transition: border 0.2s; background: white; }
//         .custom-input:focus { border-color: #0056b3; }
        
//         .search-button { padding: 11px 24px; background: #0056b3; color: white; border: none; border-radius: 8px; font-weight: 700; cursor: pointer; text-transform: uppercase; font-size: 13px; transition: background 0.2s; }
//         .search-button:hover { background: #004494; }

//         .statement-content { padding: 35px; }
//         .statement-summary { display: flex; justify-content: space-between; border-bottom: 2px solid #f1f5f9; padding-bottom: 25px; margin-bottom: 25px; align-items: flex-start; }
//         .party-name-heading { font-weight: 800; color: #1e293b; margin-bottom: 5px; }
        
//         .balance-amount { font-size: 32px; font-weight: 800; color: #0f172a; }
//         .dr-cr-badge { margin-left: 10px; font-size: 14px; padding: 2px 8px; background: #f1f5f9; color: #475569; border-radius: 6px; }
        
//         .balance-status { margin-top: 8px; font-size: 12px; font-weight: 700; display: inline-block; padding: 4px 12px; border-radius: 20px; text-transform: uppercase; }
//         .status-advance { background-color: #ecfdf5; color: #065f46; }
//         .status-payable { background-color: #fef2f2; color: #991b1b; }

//         .text-red { color: #e11d48; } .text-green { color: #10b981; }
        
//         .ledger-table { width: 100%; border-collapse: separate; border-spacing: 0; font-size: 14px; }
//         .ledger-table th { background: #f8fafc; padding: 14px; border-bottom: 2px solid #e2e8f0; text-align: left; font-size: 11px; text-transform: uppercase; color: #64748b; font-weight: 800; }
//         .ledger-table td { padding: 14px; border-bottom: 1px solid #f1f5f9; color: #334155; }
//         .transaction-row:hover { background-color: #fcfdfe; }
        
//         .footer-row td { background: #f8fafc; font-weight: 800; color: #0f172a; border-top: 2px solid #e2e8f0; }
//         .highlight-total { font-size: 16px; color: #0056b3; }
        
//         .print-btn { background: #fff; border: 1px solid #cbd5e1; padding: 10px 20px; border-radius: 8px; cursor: pointer; font-weight: 700; color: #475569; transition: all 0.2s; }
//         .print-btn:hover { background: #f8fafc; color: #0f172a; border-color: #94a3b8; }

//         @media print { .no-print { display: none; } .report-container { box-shadow: none; border: none; } .ledger-wrapper { padding: 0; background: white; } }
//       `}</style>
//     </div>
//   );
// };

// export default AgentLedger;

import React, { useState, useEffect } from "react";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";
import { useAuth } from "../../Common/Configurations/AuthContext";
import moment from "moment";
import Header from "../../Common/Layout/Header";
import AccountTabs from "../AllTabs/AccountTabs";

const AgentLedger = () => {
  const { user } = useAuth();
  const [statement, setStatement] = useState(null);
  const [agents, setAgents] = useState([]); 
  const [selectedRefId, setSelectedRefId] = useState("");
  const [fromDate, setFromDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchAgentsAndCorps = async () => {
      try {
        const customers = await apiService.getAll(`${config.GETALLCUSTOMERSBYCOMPANYID}/${user.cid}`);
        const corporates = await apiService.getAll(`${config.GETALLCOMPANIES}?companyType=CORPORATE&parentCompanyId=${user.cid}`);
        
        const combined = [
          ...customers.map(c => ({ id: c.customerId, name: `${c.customerName} (Agent)` })),
          ...corporates.map(c => ({ id: c.companyId, name: `${c.companyName} (Corporate)` })),
        ];

        combined.sort((a, b) => a.name.localeCompare(b.name));
        setAgents(combined);
      } catch (err) {
        console.error("Error fetching parties:", err);
      }
    };
    if (user?.cid) fetchAgentsAndCorps();
  }, [user?.cid]);

  const fetchStatement = async () => {
    if (!selectedRefId) return alert("Please select an Agent or Corporate");
    setLoading(true);
    try {
      const res = await apiService.getAll(`${config.GETSTATEMENT}/${selectedRefId}?fromDate=${fromDate}&toDate=${toDate}`);
      setStatement(res);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const format = (val) => Number(val).toLocaleString("en-IN", { minimumFractionDigits: 2 });

  return (
    <div id="layout-wrapper">
 <Header User={user} activeSection="accounts" />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card shadow-sm">
                
                {/* 1. TABS SECTION */}
                <div className="p-2">
                  <AccountTabs pageName="AGENTLEDGER" />
                </div>

                <div className="card-body p-0">
                  <div className="report-container">
                    
                    {/* Header & Filters Section with Blue Background */}
                    <div className="report-header">
                      <div className="d-flex justify-content-between align-items-start">
                        <div>
                          <h2 className="report-title">Agent & Corporate Ledger</h2>
                          <p className="company-id">Accounts Receivable & History</p>
                        </div>
                      </div>

                      {/* Integrated Filter Bar */}
                      <div className="filter-bar no-print mt-3">
                        <div className="filter-group flex-grow">
                          <label>Select Agent / Corporate</label>
                          <select 
                            className="custom-input" 
                            value={selectedRefId} 
                            onChange={e => setSelectedRefId(e.target.value)}
                          >
                            <option value="">-- Choose Party (Type to Search) --</option>
                            {agents.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
                          </select>
                        </div>
                        <div className="filter-group">
                          <label>From Date</label>
                          <input type="date" className="custom-input" value={fromDate} onChange={e => setFromDate(e.target.value)} />
                        </div>
                        <div className="filter-group">
                          <label>To Date</label>
                          <input type="date" className="custom-input" value={toDate} onChange={e => setToDate(e.target.value)} />
                        </div>
                        <div className="filter-group">
                          <button className="search-button" onClick={fetchStatement} disabled={loading}>
                            {loading ? "Fetching..." : "View Ledger"}
                          </button>
                        </div>
                      </div>
                    </div>

                    {statement && (
                      <div className="statement-content p-4">
                        <div className="statement-summary d-flex justify-content-between align-items-center mb-4">
                          <div className="party-details">
                            <h4 className="fw-bold mb-1">{statement.partyName || agents.find(p => p.id === selectedRefId)?.name}</h4>
                            <p className="text-muted mb-0">Period: <strong>{moment(fromDate).format("DD MMM YYYY")}</strong> - <strong>{moment(toDate).format("DD MMM YYYY")}</strong></p>
                          </div>
                          
                          <div className="balance-section text-end">
                            <div className="balance-label small text-muted text-uppercase fw-bold">Closing Balance</div>
                            <div className={`balance-amount ${statement.closingBalance >= 0 ? "text-red" : "text-green"}`}>
                               INR {format(Math.abs(statement.closingBalance))}
                               <span className="dr-cr-badge">{statement.closingBalance >= 0 ? "DR" : "CR"}</span>
                            </div>
                            
                            <div className={`balance-status ${statement.closingBalance >= 0 ? "status-payable" : "status-advance"}`}>
                                {statement.closingBalance >= 0 ? "Outstanding Due" : "Advance Received"}
                            </div>

                            {/* <div className="mt-3 no-print">
                               <button className="print-btn" onClick={() => window.print()}>
                                 <i className="ri-printer-line me-1"></i> Print Statement
                               </button>
                            </div> */}
                          </div>
                        </div>

                        <div className="table-responsive table-card">
                          <table className="ledger-table table align-middle">
                            <thead>
                              <tr>
                                <th>Date</th>
                                <th>Description</th>
                                <th>Voucher #</th>
                                <th className="text-end">Debit (Dr)</th>
                                <th className="text-end">Credit (Cr)</th>
                                <th className="text-end">Balance</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr className="opening-balance-row">
                                <td colSpan="3"><strong>Opening Balance</strong></td>
                                <td colSpan="2"></td>
                                <td className="text-end font-bold">{format(statement.openingBalance)}</td>
                              </tr>
                              {statement.transactions.map((t, i) => (
                                <tr key={i} className="transaction-row">
                                  <td>{moment(t.date).format("DD/MM/YYYY")}</td>
                                  <td>{t.description}</td>
                                  <td>{t.invoiceNumber}</td>
                                  <td className="text-end text-red">{t.debit > 0 ? format(t.debit) : "-"}</td>
                                  <td className="text-end text-green">{t.credit > 0 ? format(t.credit) : "-"}</td>
                                  <td className="text-end font-bold text-dark">{format(t.runningBalance)}</td>
                                </tr>
                              ))}
                            </tbody>
                            <tfoot>
                              <tr className="footer-row table-light fw-bold">
                                <td colSpan="3">Totals</td>
                                <td className="text-end text-red">{format(statement.totalDebit)}</td>
                                <td className="text-end text-green">{format(statement.totalCredit)}</td>
                                <td className="text-end highlight-total">{format(statement.closingBalance)}</td>
                              </tr>
                            </tfoot>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .report-container { background: white; border-radius: 8px; overflow: hidden; }
        .report-header { background: #0056b3; color: white; padding: 10px 10px; }
        .report-title { font-size: 24px; margin: 0; font-weight: 700; color: #fff; }
        .company-id { font-size: 13px; opacity: 0.9; margin-top: 5px; margin-bottom: 0; }
        
        .filter-bar {
  background: rgba(255,255,255,0.1);
  padding: 15px;
  border-radius: 8px;
  display: flex;
  gap: 15px;
  align-items: flex-end;
  width: 75%;   /* adjust as needed */
}

        .filter-group { display: flex; flex-direction: column; }
        .filter-group.flex-grow { flex: 1; }
        .filter-group label { font-size: 11px; font-weight: 700; color: #fff; margin-bottom: 5px; text-transform: uppercase; }
        .custom-input { padding: 8px 12px; border: 1px solid transparent; border-radius: 6px; font-size: 14px; outline: none; background: white; color: #333; }
        
        .search-button { padding: 9px 20px; background: white; color: #0056b3; border: none; border-radius: 6px; font-weight: 800; cursor: pointer; text-transform: uppercase; font-size: 12px; }

        .balance-amount { font-size: 32px; font-weight: 800; }
        .text-red { color: #e11d48 !important; } 
        .text-green { color: #10b981 !important; }
        
        .dr-cr-badge { margin-left: 10px; font-size: 14px; opacity: 0.8; }
        .balance-status { margin-top: 4px; font-size: 11px; font-weight: 700; display: inline-block; padding: 3px 12px; border-radius: 20px; text-transform: uppercase; }
        .status-advance { background-color: #ecfdf5; color: #065f46; }
        .status-payable { background-color: #fef2f2; color: #991b1b; }

        .ledger-table th { background: #f8fafc; font-size: 11px; text-transform: uppercase; font-weight: 800; color: #64748b; padding: 12px; border-bottom: 2px solid #e2e8f0; }
        .ledger-table td { padding: 12px; border-bottom: 1px solid #f1f5f9; font-size: 14px; }
        
        .print-btn { background: #fff; border: 1px solid #cbd5e1; padding: 8px 16px; border-radius: 6px; cursor: pointer; font-weight: 700; color: #475569; }
        .highlight-total { font-size: 16px; font-weight: 800; color: #0056b3; }

        @media print { .no-print { display: none; } .main-content { padding: 0; } .card { border: none; } }
      `}</style>
    </div>
  );
};

export default AgentLedger;